import styled, { css } from 'styled-components';

export const ResendWrapper = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  margin: 64px 0 40px 0;
  height: 60px;
`;

export const ResendButtonHelperText = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    font-family: ${theme.v2.font.family.primary};
    text-align: center;
  `}
`;

export const ResendCodeMessage = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    font-family: ${theme.v2.font.family.primary};
  `};
`;
